import React from "react";
import { useTranslation } from "react-i18next";

import Heading from "@components/layout/Heading";
import DropzoneBox from "@components/shared/DropzoneBox";
import { useEvidenceContext } from "@context/shared/EvidenceContext";
import StepActions from "@components/zenith/ui/StepActions";

type UploadEvidencesProps = {
  onPrevious: () => void;
  onSubmit: () => void;
  onCancel: () => void;
};

const UploadEvidences: React.FunctionComponent<UploadEvidencesProps> = ({
  onPrevious,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  const { evidences, getRootProps, getInputProps, handleDeleteFile } =
    useEvidenceContext();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form className="flex flex-col grow" onSubmit={handleSubmit}>
      <Heading light className="mb-8">
        {t("evidence.upload")}
      </Heading>

      <DropzoneBox
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        files={evidences}
        onDelete={handleDeleteFile}
      />

      <div className="grow" />

      <StepActions onPrevious={onPrevious} onCancel={onCancel} />
    </form>
  );
};

export default UploadEvidences;
